// Created by hejikun on 2017/10/25 0025.
const state = {
  chronicDisease_form_data: {
    user_id: '',
    // 预约类型 1 门诊预约 2 床位预约 3 检查预约 4 体检预约
    appointment_type: 0,
    // 体检人数
    service_num: 0,
    // 体检类型
    examination_type: 0,
    // 检查项目
    check_item: {
      name: '',
      id: '',
      price: '',
      fee_mode: ''
    },
    // 就诊人信息
    patient_info: {
      patient_id: '',
      patient_name: ''
    },
    // 卡信息
    card_info: {},
    // 预约医院
    appointment_hospital: {
      hos_id: '',
      hos_name: '',
      hos_type: 0 // 医院类型（1：公立，2：民营，3：诊所）
    },
    // 预约科室
    appointment_department: {
      dep_id: '', // 门诊预约时存入
      dep_name: '',
      service_id: '', // 床位预约时存入
      service_code: '' // 服务类型
    },
    // 体检项目详情
    package_detail: {},
    // 预约医生
    appointment_doctor: {
      doc_id: '',
      doc_name: '',
      flag: 0 // 如果选择医生，则自动生成预约时间 0: 未选择医生 1: 已选择医生
    },
    // 就诊时间
    appointment_time: {
      show: '', // 前台显示的时间格式
      value: 0, // 对应的时间戳
      type: 0 // 预约时间类型 1: 上午 2: 下午
    },
    // 收件人
    addressee_detail: {},
    // 意向时间
    appointment_intention_time: '',
    service_fee: 0,
    service_fee2: 0
  },
  chronicDisease_service: {}, // 医院服务
  // 预约时间
  chronicDisease_time_schedules: {
    status: 0,
    data: {}
  },
  chronicDisease_order_detail: {} // 订单详情
}

const actions = {}

const getters = {
  chronicDisease_calc_post_data(state) {
    let data = {}
    const origin = state.chronicDisease_form_data
    const service = state.chronicDisease_service
    /*
     * 预约信息
     * */
    if (service.id) {
      data.service_hospital_id = service.id // 服务-医院关联ID
    }
    if (origin.user_id) {
      data.user_id = origin.user_id // 用户ID
    }
    if (origin.appointment_time.value) {
      data.service_date = origin.appointment_time.value // 预约日期，格式 2018-01-01
    }
    if (origin.service_num) {
      data.service_num = origin.service_num // 预约日期，格式 2018-01-01
    }
    // 门诊预约、住院预约
    if (origin.patient_info.patient_id) {
      data.patient_id = origin.patient_info.patient_id // 就诊人ID 选择就诊人时必须
    }
    // 门诊预约
    if (origin.appointment_time.type) {
      data.service_time_type = origin.appointment_time.type // 预约时间类型（1：上午、2：下午） 门诊预约时必须
    }
    if (origin.appointment_type) {
      data.appointment_type = origin.appointment_type // 科室编码 门诊预约时必须
    }
    if (origin.appointment_department.dep_id) {
      data.depart_code = origin.appointment_department.dep_id // 科室编码 门诊预约时必须
    }
    if (origin.appointment_department.dep_name) {
      data.depart_name = origin.appointment_department.dep_name // 科室名称 门诊预约时必须
    }
    if (origin.appointment_doctor.doc_id) {
      data.doctor_code = origin.appointment_doctor.doc_id // 医生编码 门诊预约时如选择了医生时必须
    }
    if (origin.appointment_doctor.doc_name) {
      data.doctor_name = origin.appointment_doctor.doc_name // 医生名 门诊预约时如选择了医生时必须
    }
    // 住院预约
    if (origin.appointment_department.service_id) {
      data.hospital_depart_id = origin.appointment_department.service_id // 住院科室ID 床位预约时必须
    }
    // 检查预约、体检预约
    if (origin.check_item.id) {
      data.hospital_service_id = origin.check_item.id // 医院检查项目/体检项目ID
    }
    return data
  }
}

const mutations = {
  set_chronicDisease_form_data(state, args) {
    state.chronicDisease_form_data[args.type] = args.data
  },
  set_chronicDisease_service(state, args) {
    state.chronicDisease_service = args
  },
  set_chronicDisease_time_schedules(state, args) {
    state.chronicDisease_time_schedules = args
  },
  set_chronicDisease_order_detail(state, args) {
    state.chronicDisease_order_detail = args
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
